// modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// aliased
import Section from 'components/Section';
import Link from 'components/Link';
import Button from 'components/Button';
import SectionHeader from 'components/SectionHeader';
import RobotIcon from 'components/RobotIcon';
import { sendEvent } from 'lib/analytics';

// local
import styles from './RoboticsSection.pcss';

const learnMore = 'https://www.ohsu.edu/doernbecher/pediatric-urology';

export default class RoboticsSection extends PureComponent {
  
  static propTypes = {
    className: PropTypes.string,
  }
  static defaultProps = {}
  
  handleLearnMore = () => sendEvent('learn-more', 'robotics')
  
  render() {
    const { className } = this.props;
    
    const classNames = classnames(className, styles.roboticsSection);
    return (
      <Section id={ 'robotics' } className={ classNames }>
        <div className={ styles.content }>
          <SectionHeader image={ <RobotIcon /> }>
            { 'Robotic Surgery' }
          </SectionHeader>
          <p>
            { `
              Robotic and minimally invasive surgery can result in less pain after surgery, 
              smaller scars, and a faster recovery. The pediatric urology team at Doernbecher offers state of art, 
              robotic and minimally invasive procedures for many of our commonly performed surgeries. 
            ` }
          </p>
          <p>
            { `
              Procedures include robotic pyeloplasty for UPJ obstruction, ureteral reimplantation, 
              excision of urachal remnants, ureteral reconstruction and more.
            ` }
          </p>
          <Link
            className={ styles.learnMore }
            to={ learnMore }
            onClick={ this.handleLearnMore }
            title={ 'Learn more about robotic surgery' }
          >
            <Button className={ styles.button } tabIndex={ -1 } color={ 3 }>{ 'Learn About Robotics' }</Button>
          </Link>
        </div>
      </Section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RoboticsSection/index.jsx